import React from 'react';
import styled, { css } from 'styled-components/macro';
import { space } from 'styled-system';

import PropTypes from 'prop-types';

const size = props => {
  switch (props.size) {
    case 'small':
      return {
        fontSize: '12px',
        padding: '4px 16px',
      };
    case 'medium':
      return {
        fontSize: '16px',
        padding: '8px 24px',
      };
    case 'large':
      return {
        fontSize: '16px',
        padding: '12px 48px',
      };
    default:
      return {
        fontSize: '12px',
        padding: '8px 24px',
      };
  }
};
const primaryStyles = props =>
  props.primary &&
  css`
    background: #009688;
    color: #ffffff;
    &:active {
      background: #009688;
    }
  `;

const secondaryStyles = props =>
  props.secondary &&
  css`
    background: #dddddd;
    color: #1d1d26;
    &:active {
      background: #f7f8f7;
    }
  `;

const plainStyles = props =>
  props.plain &&
  css`
    background: transparent;
    color: #1d1d26;
    &:active {
      background: transparent;
      box-shadow: none;
    }
    box-shadow: none;
  `;

const baseStyles = props => css`
  display: block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  font-weight: 600;
  font-family: 'Sura';
  border-radius: 5px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.125);
  line-height: 1.6;
  cursor: pointer;
  border: none;
  outline: none;
  &:disabled {
    opacity: 0.75;
    cursor: none;
  }
`;

const StyledButton = styled.button`
  ${baseStyles} ${size} ${primaryStyles} ${secondaryStyles} ${plainStyles} ${space} ${props =>
  props.fullWidth ? 'width: 100%' : null};
`;
const Button = props => (
  <StyledButton {...props}>
    {props.iconBefore}
    {props.children}
    {props.iconAfter}
  </StyledButton>
);

Button.propTypes = {
  /** sets the size of the button. eg: <Button size='small'>*/
  size: PropTypes.oneOfType([PropTypes.string]),
  /** sets the width of button */
  fullWidth: PropTypes.bool,
  /** sets the styling of primary button*/
  primary: PropTypes.bool,
  /** sets the styling of secondary button*/
  secondary: PropTypes.bool,
  /** sets the styling of plain button with no background color*/
  plain: PropTypes.bool,
  /** sets the disabled style i.e. opacity*/
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  size: 'medium',
  primary: true,
};

Button.displayName = 'Button';

export default Button;
